import React from "react"
import type { ParametrosAvancadosModel } from "../models/parametrosAvancadosModel"
import { ParametrosAvancadosInicial } from "../models/parametrosAvancadosModel"
import type { ParametrosAvancadosActionModel } from "./parametrosAvancadosActions"
import { parametrosAvancadosReducer } from "./parametrosAvancadosReducer"

type ParametrosAvancadosContextType = {
    parametros: ParametrosAvancadosModel
    dispatch: React.Dispatch<ParametrosAvancadosActionModel>
    salvar: () => Promise<void>
    erroCarregamento: string | null
}

export const ParametrosAvancadosContext = React.createContext<ParametrosAvancadosContextType>({
    parametros: ParametrosAvancadosInicial,
    dispatch: () =>
        parametrosAvancadosReducer(ParametrosAvancadosInicial, {
            type: "CARREGAR" as never,
            payload: ParametrosAvancadosInicial,
        }),
    salvar: async () => {},
    erroCarregamento: null,
})
